import { alpha, type Theme } from "@mui/material/styles";

/** MUI X v8 only draws a border for today; add a visible brand-tinted fill. */
export function getDatePickerThemeOverrides(theme: Theme) {
  const primary = theme.palette.primary.main;

  return {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          "&.MuiPickersDay-today:not(.Mui-selected)": {
            border: `1px solid ${primary}`,
            backgroundColor: alpha(primary, 0.12),
          },
          "&.MuiPickersDay-today:not(.Mui-selected):hover": {
            backgroundColor: alpha(primary, 0.18),
          },
        },
      },
    },
  };
}
